import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
// import DropDown from './DropDown';
import {PlaylistAddCheckTwoTone } from '@material-ui/icons';
// import moment from 'moment';
import DropDown from './DropDown';

export default class AssessmentGroupComps extends Component {

    constructor(props) {
        super(props);
        this.reset_state = {
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            error: false,
            error_message: '',
            querying: true,
            matrix_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            search_name: '',
            search_number: '',
            searching: false,
            comps_array: [],
            show_comps: false,
            primary_button_enabled: false,
            primary_button_text: 'Link Competency'
        }
        this.state = {  //Note: assessmemt_groups not reset
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            error: false,
            error_message: '',
            querying: true,
            matrix_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            search_name: '',
            search_number: '',
            searching: false,
            comps_array: [],
            show_comps: false,
            primary_button_enabled: false,
            primary_button_text: 'Link Competency'            
        };

        this.datasheetFieldSpecs = [
            { field: 'division', headerName: 'Division', width: 115, sortable: false},
            { field: 'area', headerName: 'Area', width: 145},
            // { field: 'sort_order', headerName: '#', width: 65, headerAlign:'center', align: 'center'},
            { field: 'competency_id', headerName: 'Code', width: 80, sortable: false},
            { field: 'competency', headerName: 'Competency Narration', width: 640, sortable:false},
        ]

        this.datasheetFieldSpecs2 = [
            { field: 'Add', headerName: 'Add', width: 80, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton onClick={()=>this.addComp(parms)}>
                    <PlaylistAddCheckTwoTone/>
                </IconButton>
            )},
            { field: 'division', headerName: 'Division', width: 115, sortable:false},
            { field: 'area', headerName: 'Area', width: 145, sortable: false},
            { field: 'sort_order', headerName: '#', width: 65, headerAlign:'center', align: 'center', sortable:false},
            { field: 'competency_id', headerName: 'Code', width: 80, sortable: false},
            { field: 'competency', headerName: 'Competency Narration', width: 640, sortable:false},
        ]

        this.input_fieldSpecs = [

            {field: "division", headerName: "Division", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "area", headerName: "Area", f_inputType:'dropdown', f_show:true, f_required:true},

        ]
    }

    componentDidMount = () => {

        Gserv.sendCommand('query_comp_group_matrix',this.props.gwt,{
            assessment_group_id: this.props.group.assessment_group_id
        })
        .then(reply=>{
            // console.log('query_comp_group_matrix reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_comp_group_matrix) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_comp_group_matrix) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                // clean formats for display
                // if (reply.Records){
                // let doe = null;
                // let cycle_array = reply.Records;
                //     for (var i=0;i<cycle_array.length;i++){
                //         doe = new moment(cycle_array[i].date_of_entry).format("YYYY-MM-DD");
                //         cycle_array[i].date_of_entry = doe;
                //         // cycle_array[i].requires_nomination = cycle_array[i].requires_nomination? "YES" : "";
                //     }
                // }
                this.setState({querying:false, matrix_array:reply.Records?reply.Records : []});
            }
        });
    };

    editAssessments = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row});
    }

    addComp = (parms) => {
        this.setState({writing:true, primary_button_enabled:false});
        
        Gserv.sendCommand('create_group_comp_registry_entry',this.props.gwt,{
            competency_id : parms.id,
            assessment_group_id : this.props.group.assessment_group_id
        })
        .then(reply => {
            // console.log('create reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (create_group_comp_registry_entry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.statusCode===409){
                console.log('error on return from Gserv (create_group_comp_registry_entry) :>> ', reply);
                this.setState({error:true,error_message:"This Competency is already linked to this Asessment Group.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (create_group_comp_registry_entry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState(this.reset_state);
                this.componentDidMount();
            }
        });
    }

    handleFieldUpdate = (fieldObj) => {
        // console.log('called field update...');
        // console.log('child field update:',fieldObj);
        // console.log(this.state.current_record);
        // eslint-disable-next-line eqeqeq
        if (fieldObj.value==''){fieldObj.value=null}
        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;
        this.setState({form_data:myFormData});
        // console.log('current_record value : ',this.state.current_record[fieldObj.field]);
        // console.log('New value : ', fieldObj.value);
        // eslint-disable-next-line eqeqeq
        if(this.state.current_record[fieldObj.field]!=fieldObj.value){
            const truthyCurrentRec = this.state.current_record[fieldObj.field]? true : false;
            const truthyFieldObj = fieldObj.value ? true : false;
            //exclude nulls vs '' vs false etc.
            if (truthyCurrentRec||truthyFieldObj){
                // console.log('found update...');
                this.setState({primary_button_enabled:true});
            }
        } 
    }

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);

        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({deleting:true,querying:true});
        Gserv.sendCommand('delete_group_comp_registry_entry',this.props.gwt,{
            group_comp_registry_id: record.id
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (delete_group_comp_registry_entry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (delete_group_comp_registry_entry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState(this.reset_state);
                this.componentDidMount();
            }
        });

    }

    // openSearch = (parms) => {
    //     // console.log('edit assessments with parms :>> ', parms);
    //     this.setState({current_record:parms.row,nominate_view:true});
    // }

    runSearch = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);

        if (!this.state.form_data.division||!this.state.form_data.area){return}

        this.setState({searching:true, primary_button_enabled:false});
        Gserv.sendCommand('find_competencies_from_filter',this.props.gwt,{
            division: this.state.form_data.division,
            area: this.state.form_data.area
        })
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_competencies_from_filter) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_competencies_from_filter) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({comps_array:[],show_comps:true,searching:false,primary_button_enabled:true});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                // if (reply.Records){
                //     let record_array = reply.Records;
                //     let DOE = null;
                //     for (var i=0;i<record_array.length;i++){
                //         DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                //         record_array[i].date_of_entry = DOE;
                //     }
                // }
                this.setState({comps_array:reply.Records,show_comps:true,searching:false,primary_button_enabled:true});

            }
        });
    }

    resetMe = () => {
        this.setState(this.reset_state);
        this.componentDidMount();
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
                
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        width:1060
                    }}
                >
                    <Typography
                        style={{paddingTop:15}}
                    >
                       Competency Assessment Group: <b>{this.props.group.assessment_group}</b>
                    </Typography> 
    
                    <hr/>
                    <Typography
                        color='primary'
                        style={{paddingTop:15}}
                    >
                        Associate Competencies with this Assessment Group
                    </Typography>
                    <Grid
                        container
                        direction='row'
                        justifyContent='center'
                        alignContent='center'
                        style={{padding:15}}
                    >
                        {!this.state.form_view&&
                        <div>
                        <Button
                            variant='contained'
                            color='primary'
                            // type='submit'
                            onClick={()=>this.setState({form_view:true,primary_button_text:'Link',current_record:{}})}
                            disabled={this.state.form_view}
                        >
                            Link New Competency to Group
                        </Button>
                        <Button 
                            // type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={()=>this.props.setParentState({comps_view:false})}
                            style={{marginLeft:'15px'}}
                        >
                            Back
                        </Button>
                        </div>}
                    </Grid>
                </Paper>
                </Grid>
                <Grid item>
                    <Typography color='secondary' style={{Width:1060,maxWidth:1060, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

                {/* {this.state.querying&&
                <Grid item>
                    <br/>
                    <Settings className='icn-spinner' /> Querying...
                </Grid>} */}

                {/* Datagrid goes here */}
                {!this.state.form_view&&
                <DatasheetView 
                    dataset={this.state.matrix_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={true}
                    edit={false}
                    handleDelete={this.handleDelete}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={8}
                />}

                {this.state.form_view&&
                <div>    
                <hr/>    

                {/* Select Division, then area, then competency */}

                <Typography
                    color='primary'
                    style={{paddingTop:10}}
                >
                    Please select a Competency to link to this Assessment Group
                </Typography>
                <Typography>
                    {}
                </Typography>

                <Grid
                    container
                    direction='column'
                    justifyContent='space-evenly'
                    alignContent='center'
                    style={{padding:15}}
                >

                    <form onSubmit={this.runSearch}>
                        
                        <div style={{marginBottom:'10px', marginRight:'10px'}}>
                            <DropDown fieldMap={this.input_fieldSpecs[0]} setField={this.handleFieldUpdate} editRecord={{}} listArray={this.props.divisions} disabled={this.state.writing}/>
                        </div>

                        <div style={{marginBottom:'10px', marginLeft:'10px'}}>
                            <DropDown fieldMap={this.input_fieldSpecs[1]} setField={this.handleFieldUpdate} editRecord={{}} listArray={this.props.areas} disabled={this.state.writing}/>
                        </div>

                        <br/>
                        <Button
                            variant='contained'
                            color='primary'
                            type='submit'
                            disabled={!this.state.primary_button_enabled}
                        >
                            {this.state.show_comps? 'Refresh' : 'Next'}
                        </Button>
                        <Button
                            variant='contained'
                            onClick={()=>this.setState({form_view:false,search_name:'',primary_button_enabled:false,searching:false,current_record:{},error:false,error_message:'',show_comps:false})}
                            style={{marginLeft:'10px'}}
                            // color='primary'
                            // type='submit'
                            disabled={this.state.writing}
                        >
                            Back
                        </Button>
                    </form>
                </Grid>
                </div>}

                {this.state.show_comps&&
                <DatasheetView 
                    dataset={this.state.comps_array}
                    fieldspecs={this.datasheetFieldSpecs2}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.searching}
                    deleteHeaderName={'Delete'}
                    height={350}
                />}
     

            </Grid>
        );
    }
    
}